import View                    from '@widesk-ui/components/View';
import { observer }            from 'mobx-react-lite';
import BadgeDisplayField       from '@/TokamapEditor/ux/AreaSidebar/BadgeDisplayField';
import SidebarTabs             from '@/TokamapEditor/ux/AreaSidebar/SidebarTabs';
import AreaImageSection        from '@/TokamapEditor/ux/AreaSidebar/AreaImageSection';
import AreaTextSection         from '@/TokamapEditor/ux/AreaSidebar/AreaTextSection';
import { PictureOutlined }     from '@ant-design/icons';
import { FontColorsOutlined }  from '@ant-design/icons';
import React                   from 'react';

const AreaContentSection = observer(() => {
	const [tab, setTab] = React.useState<'image' | 'text'>('image');

	return (
		<View gap="lg">
			<BadgeDisplayField />

			<View gap="md">
				<SidebarTabs
					value={tab}
					onChange={setTab}
					options={[
						{ value: 'image', label: 'Image', icon: <PictureOutlined /> },
						{ value: 'text', label: 'Texte', icon: <FontColorsOutlined /> },
					]}
				/>

				{tab === 'image' ? <AreaImageSection /> : <AreaTextSection />}
			</View>
		</View>
	);
});

export default AreaContentSection;
